import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class HeaderFixed extends kr.Component {
    init() {
        this.bounceEvent = false;
        this.bind();
    }

    bind() {
        window.addEventListener('scroll', () => {
            if (this.bounceEvent) {
                return false;
            }
            this.bounceEvent = true;
            setTimeout(() => {
                this._checkScrollTop();
                this.bounceEvent = false;
            }, 50);
        });

        window.addEventListener('domready', () => {
            this._checkScrollTop();
        });
    }

    _checkScrollTop() {
        const top = window.pageYOffset;

        if (top > 0){
            HTMLClass.addClass(this.app.dom.$body, 'header--fixed');
            

        } else {
            HTMLClass.removeClass(this.app.dom.$body, 'header--fixed');
        }
    }
}

kr.registerComponent('.header', {
    component: HeaderFixed
});